// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  background-size: 610% 100% !important;
  background-position: center bottom !important;
  background-repeat: no-repeat !important;
  background-attachment: fixed !important;
  background-image: url('background_default.webp') !important;
}

.payment-success-content .container {
  max-width: 720px;
  margin: 0 auto;
  padding: 24px 20px;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}

.logo-section {
  text-align: center;
  margin-top: 30px;
  margin-bottom: 30px;
}
.logo-section .brand-logo {
  width: 120px;
  height: 100px;
}

.success-card {
  background: white;
  padding: 32px 24px;
  margin-bottom: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  border-radius: var(--radius-default);
  border: var(--outline-default);
}

.title-message {
  text-align: center;
  margin-bottom: 5px;
  padding-bottom: 15px;
}
.title-message h1 {
  font-family: AppFontMedium;
  font-size: 16px;
  line-height: 135%;
  letter-spacing: 0;
  text-align: center;
  vertical-align: middle;
  margin: 0;
}

.thank-you-message {
  text-align: center;
  padding-bottom: 24px;
}
.thank-you-message h1 {
  font-family: "AppFont", sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 1.5;
  color: #666666;
  margin: 0;
}

.order-details {
  margin-bottom: 24px;
  padding-bottom: 24px;
  padding-top: 24px;
  border-bottom: var(--outline-default);
  border-top: var(--outline-default);
}
.order-details .detail-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}
.order-details .detail-row:last-child {
  margin-bottom: 0;
}
.order-details .detail-row .detail-label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: AppFont, sans-serif;
  font-size: 14px;
  color: #41413f;
}
.order-details .detail-row .detail-label span {
  font-family: inherit;
  font-size: inherit;
  color: inherit;
}
.order-details .detail-row .detail-label ion-icon {
  font-size: 18px;
  color: var(--color-grey);
}
.order-details .detail-row .detail-value {
  text-align: right;
  font-family: AppFont, sans-serif;
  font-size: 14px;
  color: #41413f;
}
.order-details .detail-row .detail-value span {
  font-family: inherit;
  font-size: inherit;
  color: inherit;
}
.order-details .detail-row .chip-table {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 27px;
  min-width: 50px;
  padding-inline: 6px;
  background-color: transparent;
  border-radius: var(--radius-default);
  border: 1px solid var(--color-black);
  font-family: AppFontMedium;
  font-size: 16px;
  line-height: 100%;
  letter-spacing: 0%;
  vertical-align: middle;
  text-transform: capitalize;
  color: var(--color-black);
}

.preparing-status {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #5c5c5c;
  font-size: 13px;
}
.preparing-status ion-spinner {
  width: 16px;
  height: 16px;
}

.download-receipt {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  background: #1d1d1b;
  color: white;
  border-radius: 4px;
  cursor: pointer;
  transition: background 0.2s;
}
.download-receipt:hover {
  background: #1a1a1a;
}
.download-receipt span {
  font-size: 12px;
  font-weight: 500;
  color: #fff;
}
.download-receipt ion-icon {
  width: 14px;
  height: 14px;
}

.order-items {
  margin-bottom: 24px;
}
.order-items .item-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 5px;
}
.order-items .item-row .item-info {
  display: flex;
  gap: 8px;
  flex: 1;
}
.order-items .item-row .item-info .item-quantity {
  font-family: AppFont, sans-serif;
  font-size: 14px;
  color: #656564;
}
.order-items .item-row .item-info .item-name {
  font-family: AppFont, sans-serif;
  font-size: 14px;
  color: #656564;
}
.order-items .item-row .item-info span {
  font-family: inherit;
  font-size: inherit;
  color: inherit;
}
.order-items .item-row .item-price {
  font-family: AppFont, sans-serif;
  font-size: 14px;
  color: #656564;
  white-space: nowrap;
  margin-left: 16px;
}
.order-items .item-option {
  padding-left: 32px;
  margin-bottom: 0px;
  font-family: AppFont, sans-serif;
  font-size: 12px;
  color: #656564;
}
.order-items .item-option span {
  font-family: inherit;
  font-size: inherit;
  color: inherit;
}
.order-items .tip-row {
  margin-top: 16px;
  padding-top: 16px;
}
.order-items .tip-row .tip-info,
.order-items .tip-row .tip-price {
  font-family: AppFontMedium;
  font-size: 16px;
  color: var(--color-black);
}

.miles-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px dashed #e0e0e0;
}
.miles-row .miles-img {
  height: 18px;
  width: auto;
}
.miles-row .miles-value {
  font-family: "AppFont", sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #226086;
}

.total-section {
  padding: 20px 0 0;
  border-top: var(--outline-default);
}
.total-section .total-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.total-section .total-row .total-label,
.total-section .total-row .total-amount {
  font-family: AppFontMedium, sans-serif;
  font-size: 18px;
  color: var(--color-black);
}

.review-section {
  text-align: center;
  padding: 6px 0 12px;
}
.review-section .review-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px 24px;
  background: #fff;
  border: 1px solid var(--color-black);
  color: var(--color-black);
  border-radius: var(--radius-default);
  cursor: pointer;
  transition: background 0.2s;
  width: 278px;
  height: 44px;
}
.review-section .review-button ion-icon {
  font-size: 18px;
  color: #ffd700;
}
.review-section .review-button .feedback-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.review-section .review-button .feedback-container span {
  font-size: 16px;
  line-height: 18px;
  font-family: AppFontMedium;
  color: var(--color-black);
}

.footer-message {
  text-align: center;
  margin-bottom: 16px;
  margin-top: auto;
}
.footer-message p {
  font-family: "AppFont", sans-serif;
  font-size: 14px;
  line-height: 1.5;
  color: #5c5c5c;
  margin: 0;
}

ion-footer {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: transparent;
}
ion-footer .order-button-section {
  width: 100%;
  background: #fff;
  box-shadow: 2px 2px 5.1px 0px rgba(13, 31, 10, 0.2);
  padding: 16px 18px;
}
ion-footer .final-text {
  font-family: AppFont;
  font-size: 12px;
  line-height: 150%;
  letter-spacing: -0.01em;
  text-align: center;
  color: var(--color-white);
  margin-bottom: 12px;
}

@media (max-width: 768px) {
  .payment-success-content .container {
    height: 100%;
    padding: 16px 16px;
  }
  .success-card {
    padding: 24px 16px;
  }
  .logo-section .brand-logo {
    width: 220px;
  }
}
@media (max-width: 480px) {
  .detail-row {
    align-items: flex-start !important;
    gap: 8px;
  }
  .detail-row .detail-value {
    text-align: left !important;
  }
  .order-details .detail-row .detail-label {
    font-size: 13px;
  }
  .order-details .detail-row .detail-value {
    font-size: 13px;
  }
}
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}
.loading-overlay ion-spinner {
  width: 48px;
  height: 48px;
  color: white;
}

.error-message {
  background: #ffebee;
  color: #c62828;
  padding: 12px 16px;
  border-radius: 4px;
  margin-bottom: 16px;
  text-align: center;
  font-family: "AppFont", sans-serif;
  font-size: 14px;
}

.status-tabs {
  display: flex;
  gap: 10px;
  margin-bottom: 24px;
}
.status-tabs .status-tab {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
}
.status-tabs .status-tab .status-indicator {
  width: 100%;
  height: 10px;
  background: #e0e0e0;
  transition: background 0.3s ease;
}
.status-tabs .status-tab span {
  font-family: "AppFont", sans-serif;
  font-size: 13px;
  color: #9e9e9e;
  transition: color 0.3s ease;
}
.status-tabs .status-tab.active .status-indicator {
  background: #c6aa7a;
}
.status-tabs .status-tab.active span {
  color: #2c2c2c;
  font-weight: 600;
}
.status-tabs .status-tab:hover {
  opacity: 0.8;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/payment-success/payment-success.page.scss"],"names":[],"mappings":"AAEA;EACC,qCAAA;EACA,6CAAA;EACA,uCAAA;EACA,uCAAA;EACA,2DAAA;AADD;;AAiBC;EACC,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;AAdF;;AAmBA;EACC,kBAAA;EACA,gBAAA;EACA,mBAAA;AAhBD;AAkBC;EACC,YAAA;EACA,aAAA;AAhBF;;AAqBA;EACC,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,yCAAA;EACA,oCAAA;EACA,8BAAA;AAlBD;;AAsBA;EACC,kBAAA;EACA,kBAAA;EACA,oBAAA;AAnBD;AAqBC;EACC,0BAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EAEA,SAAA;AApBF;;AAyBA;EACC,kBAAA;EACA,oBAAA;AAtBD;AAwBC;EACC,kCAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;AAtBF;;AA2BA;EACC,mBAAA;EACA,oBAAA;EACA,iBAAA;EACA,qCAAA;EACA,kCAAA;AAxBD;AA0BC;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AAxBF;AA0BE;EACC,gBAAA;AAxBH;AA2BE;EACC,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gCAAA;EACA,eAAA;EACA,cAAA;AAzBH;AA2BG;EACC,oBAAA;EACA,kBAAA;EACA,cAAA;AAzBJ;AA4BG;EACC,eAAA;EACA,wBAAA;AA1BJ;AA8BE;EACC,iBAAA;EAEA,gCAAA;EACA,eAAA;EACA,cAAA;AA7BH;AA+BG;EACC,oBAAA;EACA,kBAAA;EACA,cAAA;AA7BJ;AAiCE;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;EAEA,6BAAA;EACA,oCAAA;EACA,oCAAA;EAEA,0BAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,0BAAA;EACA,yBAAA;AAjCH;;AAuCA;EACC,aAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,eAAA;AApCD;AAsCC;EACC,WAAA;EACA,YAAA;AApCF;;AAyCA;EACC,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,2BAAA;AAtCD;AAwCC;EACC,mBAAA;AAtCF;AAyCC;EACC,eAAA;EACA,gBAAA;EACA,WAAA;AAvCF;AA0CC;EACC,WAAA;EACA,YAAA;AAxCF;;AA6CA;EACC,mBAAA;AA1CD;AA4CC;EACC,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,kBAAA;AA1CF;AA4CE;EACC,aAAA;EACA,QAAA;EACA,OAAA;AA1CH;AA4CG;EACC,gCAAA;EACA,eAAA;EACA,cAAA;AA1CJ;AA6CG;EACC,gCAAA;EACA,eAAA;EACA,cAAA;AA3CJ;AA8CG;EACC,oBAAA;EACA,kBAAA;EACA,cAAA;AA5CJ;AAgDE;EACC,gCAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;EACA,iBAAA;AA9CH;AAkDC;EACC,kBAAA;EACA,kBAAA;EACA,gCAAA;EACA,eAAA;EACA,cAAA;AAhDF;AAkDE;EACC,oBAAA;EACA,kBAAA;EACA,cAAA;AAhDH;AAoDC;EACC,gBAAA;EACA,iBAAA;AAlDF;AAoDE;;EAEC,0BAAA;EACA,eAAA;EACA,yBAAA;AAlDH;;AAwDA;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,8BAAA;AArDD;AAuDC;EACC,YAAA;EACA,WAAA;AArDF;AAwDC;EACC,kCAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAtDF;;AA2DA;EACC,iBAAA;EACA,kCAAA;AAxDD;AA0DC;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;AAxDF;AA0DE;;EAEC,sCAAA;EACA,eAAA;EACA,yBAAA;AAxDH;;AA8DA;EACC,kBAAA;EACA,mBAAA;AA3DD;AA6DC;EACC,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,kBAAA;EACA,gBAAA;EACA,oCAAA;EACA,yBAAA;EACA,oCAAA;EACA,eAAA;EACA,2BAAA;EACA,YAAA;EACA,YAAA;AA3DF;AA6DE;EACC,eAAA;EACA,cAAA;AA3DH;AA8DE;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;AA5DH;AA8DG;EACC,eAAA;EACA,iBAAA;EACA,0BAAA;EACA,yBAAA;AA5DJ;;AAmEA;EACC,kBAAA;EACA,mBAAA;EACA,gBAAA;AAhED;AAkEC;EACC,kCAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;AAhEF;;AAoEA;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EAEA,uBAAA;AAlED;AAoEC;EACC,WAAA;EACA,gBAAA;EACA,mDAAA;EACA,kBAAA;AAlEF;AAqEC;EACC,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,uBAAA;EACA,kBAAA;EACA,yBAAA;EAEA,mBAAA;AApEF;;AAyEA;EACC;IACC,YAAA;IACA,kBAAA;EAtEA;EAyED;IACC,kBAAA;EAvEA;EA0ED;IACC,YAAA;EAxEA;AACF;AA2EA;EACC;IACC,kCAAA;IACA,QAAA;EAzEA;EA2EA;IACC,2BAAA;EAzED;EA6ED;IACC,eAAA;EA3EA;EA8ED;IACC,eAAA;EA5EA;AACF;AAgFA;EACC,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;AA9ED;AAgFC;EACC,WAAA;EACA,YAAA;EACA,YAAA;AA9EF;;AAmFA;EACC,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kCAAA;EACA,eAAA;AAhFD;;AAoFA;EACC,aAAA;EACA,SAAA;EACA,mBAAA;AAjFD;AAmFC;EACC,OAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,yBAAA;AAjFF;AAmFE;EACC,WAAA;EACA,YAAA;EACA,mBAAA;EACA,gCAAA;AAjFH;AAoFE;EACC,kCAAA;EACA,eAAA;EACA,cAAA;EACA,2BAAA;AAlFH;AAsFG;EACC,mBAAA;AApFJ;AAuFG;EACC,cAAA;EACA,gBAAA;AArFJ;AAyFE;EACC,YAAA;AAvFH","sourcesContent":["@use '../../../theme/mixins' as *;\n\n:host {\n\tbackground-size: 610% 100% !important;\n\tbackground-position: center bottom !important;\n\tbackground-repeat: no-repeat !important;\n\tbackground-attachment: fixed !important;\n\tbackground-image: url('../../../assets/customer/background_default.webp') !important;\n}\n\n.payment-success-content {\n\t// &::before {\n\t// \tcontent: '';\n\t// \tposition: fixed;\n\t// \ttop: 0;\n\t// \tleft: 0;\n\t// \tright: 0;\n\t// \tbottom: 0;\n\t// \tbackground: rgba(255, 255, 255, 0.65);\n\t// \tpointer-events: none;\n\t// \tz-index: 0;\n\t// }\n\n\t.container {\n\t\tmax-width: 720px;\n\t\tmargin: 0 auto;\n\t\tpadding: 24px 20px;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\toverflow-y: auto;\n\t}\n}\n\n// Logo Section\n.logo-section {\n\ttext-align: center;\n\tmargin-top: 30px;\n\tmargin-bottom: 30px;\n\n\t.brand-logo {\n\t\twidth: 120px;\n\t\theight: 100px;\n\t}\n}\n\n// Success Card\n.success-card {\n\tbackground: white;\n\tpadding: 32px 24px;\n\tmargin-bottom: 20px;\n\tbox-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n\tborder-radius: var(--radius-default);\n\tborder: var(--outline-default);\n}\n\n// Title Message\n.title-message {\n\ttext-align: center;\n\tmargin-bottom: 5px;\n\tpadding-bottom: 15px;\n\n\th1 {\n\t\tfont-family: AppFontMedium;\n\t\tfont-size: 16px;\n\t\tline-height: 135%;\n\t\tletter-spacing: 0;\n\t\ttext-align: center;\n\t\tvertical-align: middle;\n\n\t\tmargin: 0;\n\t}\n}\n\n// Thank You Message\n.thank-you-message {\n\ttext-align: center;\n\tpadding-bottom: 24px;\n\n\th1 {\n\t\tfont-family: 'AppFont', sans-serif;\n\t\tfont-size: 12px;\n\t\tfont-weight: 400;\n\t\tline-height: 1.5;\n\t\tcolor: #666666;\n\t\tmargin: 0;\n\t}\n}\n\n// Order Details Section\n.order-details {\n\tmargin-bottom: 24px;\n\tpadding-bottom: 24px;\n\tpadding-top: 24px;\n\tborder-bottom: var(--outline-default);\n\tborder-top: var(--outline-default);\n\n\t.detail-row {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\talign-items: center;\n\t\tmargin-bottom: 16px;\n\n\t\t&:last-child {\n\t\t\tmargin-bottom: 0;\n\t\t}\n\n\t\t.detail-label {\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tgap: 8px;\n\t\t\tfont-family: AppFont, sans-serif;\n\t\t\tfont-size: 14px;\n\t\t\tcolor: #41413f;\n\n\t\t\tspan {\n\t\t\t\tfont-family: inherit;\n\t\t\t\tfont-size: inherit;\n\t\t\t\tcolor: inherit;\n\t\t\t}\n\n\t\t\tion-icon {\n\t\t\t\tfont-size: 18px;\n\t\t\t\tcolor: var(--color-grey);\n\t\t\t}\n\t\t}\n\n\t\t.detail-value {\n\t\t\ttext-align: right;\n\n\t\t\tfont-family: AppFont, sans-serif;\n\t\t\tfont-size: 14px;\n\t\t\tcolor: #41413f;\n\n\t\t\tspan {\n\t\t\t\tfont-family: inherit;\n\t\t\t\tfont-size: inherit;\n\t\t\t\tcolor: inherit;\n\t\t\t}\n\t\t}\n\n\t\t.chip-table {\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: center;\n\t\t\talign-items: center;\n\t\t\theight: 27px;\n\t\t\tmin-width: 50px;\n\t\t\tpadding-inline: 6px;\n\n\t\t\tbackground-color: transparent;\n\t\t\tborder-radius: var(--radius-default);\n\t\t\tborder: 1px solid var(--color-black);\n\n\t\t\tfont-family: AppFontMedium;\n\t\t\tfont-size: 16px;\n\t\t\tline-height: 100%;\n\t\t\tletter-spacing: 0%;\n\t\t\tvertical-align: middle;\n\t\t\ttext-transform: capitalize;\n\t\t\tcolor: var(--color-black);\n\t\t}\n\t}\n}\n\n// Preparing Status\n.preparing-status {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 6px;\n\tcolor: #5c5c5c;\n\tfont-size: 13px;\n\n\tion-spinner {\n\t\twidth: 16px;\n\t\theight: 16px;\n\t}\n}\n\n// Download Receipt Button\n.download-receipt {\n\tdisplay: inline-flex;\n\talign-items: center;\n\tgap: 6px;\n\tpadding: 6px 12px;\n\tbackground: #1d1d1b;\n\tcolor: white;\n\tborder-radius: 4px;\n\tcursor: pointer;\n\ttransition: background 0.2s;\n\n\t&:hover {\n\t\tbackground: #1a1a1a;\n\t}\n\n\tspan {\n\t\tfont-size: 12px;\n\t\tfont-weight: 500;\n\t\tcolor: #fff;\n\t}\n\n\tion-icon {\n\t\twidth: 14px;\n\t\theight: 14px;\n\t}\n}\n\n// Order Items Section\n.order-items {\n\tmargin-bottom: 24px;\n\n\t.item-row {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\talign-items: flex-start;\n\t\tmargin-bottom: 5px;\n\n\t\t.item-info {\n\t\t\tdisplay: flex;\n\t\t\tgap: 8px;\n\t\t\tflex: 1;\n\n\t\t\t.item-quantity {\n\t\t\t\tfont-family: AppFont, sans-serif;\n\t\t\t\tfont-size: 14px;\n\t\t\t\tcolor: #656564;\n\t\t\t}\n\n\t\t\t.item-name {\n\t\t\t\tfont-family: AppFont, sans-serif;\n\t\t\t\tfont-size: 14px;\n\t\t\t\tcolor: #656564;\n\t\t\t}\n\n\t\t\tspan {\n\t\t\t\tfont-family: inherit;\n\t\t\t\tfont-size: inherit;\n\t\t\t\tcolor: inherit;\n\t\t\t}\n\t\t}\n\n\t\t.item-price {\n\t\t\tfont-family: AppFont, sans-serif;\n\t\t\tfont-size: 14px;\n\t\t\tcolor: #656564;\n\t\t\twhite-space: nowrap;\n\t\t\tmargin-left: 16px;\n\t\t}\n\t}\n\n\t.item-option {\n\t\tpadding-left: 32px;\n\t\tmargin-bottom: 0px;\n\t\tfont-family: AppFont, sans-serif;\n\t\tfont-size: 12px;\n\t\tcolor: #656564;\n\n\t\tspan {\n\t\t\tfont-family: inherit;\n\t\t\tfont-size: inherit;\n\t\t\tcolor: inherit;\n\t\t}\n\t}\n\n\t.tip-row {\n\t\tmargin-top: 16px;\n\t\tpadding-top: 16px;\n\n\t\t.tip-info,\n\t\t.tip-price {\n\t\t\tfont-family: AppFontMedium;\n\t\t\tfont-size: 16px;\n\t\t\tcolor: var(--color-black);\n\t\t}\n\t}\n}\n\n// Miles & More Section\n.miles-row {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\tmargin-top: 16px;\n\tpadding-top: 16px;\n\tborder-top: 1px dashed #e0e0e0;\n\n\t.miles-img {\n\t\theight: 18px;\n\t\twidth: auto;\n\t}\n\n\t.miles-value {\n\t\tfont-family: 'AppFont', sans-serif;\n\t\tfont-size: 14px;\n\t\tfont-weight: 600;\n\t\tcolor: #226086;\n\t}\n}\n\n// Total Section\n.total-section {\n\tpadding: 20px 0 0;\n\tborder-top: var(--outline-default);\n\n\t.total-row {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\talign-items: center;\n\n\t\t.total-label,\n\t\t.total-amount {\n\t\t\tfont-family: AppFontMedium, sans-serif;\n\t\t\tfont-size: 18px;\n\t\t\tcolor: var(--color-black);\n\t\t}\n\t}\n}\n\n// Review Section\n.review-section {\n\ttext-align: center;\n\tpadding: 6px 0 12px;\n\n\t.review-button {\n\t\tdisplay: inline-flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\tgap: 8px;\n\t\tpadding: 12px 24px;\n\t\tbackground: #fff;\n\t\tborder: 1px solid var(--color-black);\n\t\tcolor: var(--color-black);\n\t\tborder-radius: var(--radius-default);\n\t\tcursor: pointer;\n\t\ttransition: background 0.2s;\n\t\twidth: 278px;\n\t\theight: 44px;\n\n\t\tion-icon {\n\t\t\tfont-size: 18px;\n\t\t\tcolor: #ffd700;\n\t\t}\n\n\t\t.feedback-container {\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: column;\n\t\t\talign-items: center;\n\n\t\t\tspan {\n\t\t\t\tfont-size: 16px;\n\t\t\t\tline-height: 18px;\n\t\t\t\tfont-family: AppFontMedium;\n\t\t\t\tcolor: var(--color-black);\n\t\t\t}\n\t\t}\n\t}\n}\n\n// Footer Message\n.footer-message {\n\ttext-align: center;\n\tmargin-bottom: 16px;\n\tmargin-top: auto;\n\n\tp {\n\t\tfont-family: 'AppFont', sans-serif;\n\t\tfont-size: 14px;\n\t\tline-height: 1.5;\n\t\tcolor: #5c5c5c;\n\t\tmargin: 0;\n\t}\n}\n\nion-footer {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tjustify-content: center;\n\n\tbackground: transparent;\n\n\t.order-button-section {\n\t\twidth: 100%;\n\t\tbackground: #fff;\n\t\tbox-shadow: 2px 2px 5.1px 0px #0d1f0a33;\n\t\tpadding: 16px 18px;\n\t}\n\n\t.final-text {\n\t\tfont-family: AppFont;\n\t\tfont-size: 12px;\n\t\tline-height: 150%;\n\t\tletter-spacing: -0.01em;\n\t\ttext-align: center;\n\t\tcolor: var(--color-white);\n\n\t\tmargin-bottom: 12px;\n\t}\n}\n\n// Responsive Design\n@media (max-width: 768px) {\n\t.payment-success-content .container {\n\t\theight: 100%;\n\t\tpadding: 16px 16px;\n\t}\n\n\t.success-card {\n\t\tpadding: 24px 16px;\n\t}\n\n\t.logo-section .brand-logo {\n\t\twidth: 220px;\n\t}\n}\n\n@media (max-width: 480px) {\n\t.detail-row {\n\t\talign-items: flex-start !important;\n\t\tgap: 8px;\n\n\t\t.detail-value {\n\t\t\ttext-align: left !important;\n\t\t}\n\t}\n\n\t.order-details .detail-row .detail-label {\n\t\tfont-size: 13px;\n\t}\n\n\t.order-details .detail-row .detail-value {\n\t\tfont-size: 13px;\n\t}\n}\n\n// Loading State\n.loading-overlay {\n\tposition: fixed;\n\ttop: 0;\n\tleft: 0;\n\tright: 0;\n\tbottom: 0;\n\tbackground: rgba(0, 0, 0, 0.5);\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tz-index: 9999;\n\n\tion-spinner {\n\t\twidth: 48px;\n\t\theight: 48px;\n\t\tcolor: white;\n\t}\n}\n\n// Error State\n.error-message {\n\tbackground: #ffebee;\n\tcolor: #c62828;\n\tpadding: 12px 16px;\n\tborder-radius: 4px;\n\tmargin-bottom: 16px;\n\ttext-align: center;\n\tfont-family: 'AppFont', sans-serif;\n\tfont-size: 14px;\n}\n\n// Status Tabs\n.status-tabs {\n\tdisplay: flex;\n\tgap: 10px;\n\tmargin-bottom: 24px;\n\n\t.status-tab {\n\t\tflex: 1;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: center;\n\t\tgap: 8px;\n\t\tcursor: pointer;\n\t\ttransition: all 0.3s ease;\n\n\t\t.status-indicator {\n\t\t\twidth: 100%;\n\t\t\theight: 10px;\n\t\t\tbackground: #e0e0e0;\n\t\t\ttransition: background 0.3s ease;\n\t\t}\n\n\t\tspan {\n\t\t\tfont-family: 'AppFont', sans-serif;\n\t\t\tfont-size: 13px;\n\t\t\tcolor: #9e9e9e;\n\t\t\ttransition: color 0.3s ease;\n\t\t}\n\n\t\t&.active {\n\t\t\t.status-indicator {\n\t\t\t\tbackground: #c6aa7a;\n\t\t\t}\n\n\t\t\tspan {\n\t\t\t\tcolor: #2c2c2c;\n\t\t\t\tfont-weight: 600;\n\t\t\t}\n\t\t}\n\n\t\t&:hover {\n\t\t\topacity: 0.8;\n\t\t}\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
